import {StyleSheet} from 'react-native';

export const styles =  StyleSheet.create(
{
    page: {
    },

    title: {
        fontSize: 36,
        color: '#535353',
        fontFamily: 'Montserrat',
        fontWeight: '700', 
        marginTop: 64,
        marginBottom: 64
    },

    documentsRow: {
       flexDirection: 'row', 
       flexWrap: 'wrap'
    },

    documentsCol: {
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
    },

    row: {
        flexDirection: 'row',
        alignItems: 'center',
        marginRight: 16,
        marginBottom: 20
    },

    mobileRow: {
        width: '85vw',
        shadowColor: "#0000006b",
        shadowOffset: {
            width: 1,
            height: 0
        },
        marginRight: 0,
        shadowOpacity: 0.3,
        shadowRadius: 10,
        borderRadius: 8,
        paddingVertical: 8,
        paddingHorizontal: 18
    },

    documentTitle: {
        fontSize: 20,
        color: '#535353',
        fontFamily: 'Montserrat',
        fontWeight: '400',
    },

    infoText: {
        fontSize: 12,
        color: '#535353',
        fontFamily: 'Montserrat',
        fontWeight: '400',
        marginTop: 5
    },

    documentImage: {
        height: 32,
        width: 32,
        marginRight: 18
    }
});